<template lang="pug">
    .text-center.w-100.d-inline-flex.position-relative.stepOutsideBox
      .stepBox.position-relative(
          v-for="(step,index) in stepArr",
          :style="stepBarDivLength"
        )
        div.position-relative.w-100
          .stepBox__upPart.mb-2(
            :class="{ 'active': nowStep >= index + 2}",
            :style="nowStep >= index + 2 ? spanActiveColor : spanDefaultColor "
          )
            div.span.d-flex.align-items-center.justify-content-center(
              :class="{ 'active': nowStep >= index + 1, 'cursor-pointer': nowStep >= index + 1}",
              :style="nowStep >= index + 1 ? spanActiveColor : spanDefaultColor ",
              @click="changeStep( index + 1 )"
            )
              span.p-2(
                v-if="index + 1 < nowStep"
              )
                b-img.icon(
                    fluid,
                    :src="require('@/assets/images/icon/icon_ok.png')"
                )
              span(
                v-else
              ) {{ index + 1 }}
          .stepBox__downPart
            span.span(
              :class="{ 'active': nowStep >= index + 1}",
              :style="nowStep >= index + 1 ? spanActiveColor : spanDefaultColor "
            ) {{ step.title }}
</template>

<script>
export default {
  name: 'StepComponent',
  props: {
    // 項目標題
    stepArr: {
      type: Array,
      required: true
    },
    nowStep: {
      type: Number,
      required: true
    },
    // 沒選種顏色
    defaultColor: {
      type: String,
      default: '#FFF'
    },
    // 選中後顏色
    actionColor: {
      type: String,
      default: '#333'
    }
  },
  methods: {
    // 跳頁
    changeStep(page) {
      const vm = this;
      // 呼叫父元件
      vm.$emit('changeStep', page);
    }
  },
  // 這邊用來帶入變數到 CSS
  computed: {
    // 沒選時候的顏色
    spanDefaultColor() {
      return {
        '--spanDefaultColor': this.defaultColor
      };
    },
    // 選中的顏色
    spanActiveColor() {
      return {
        '--spanActiveColor': this.actionColor
      };
    },
    // 每一個 Div 的寬
    stepBarDivLength() {
      return {
        '--stepBarDivWidth': this.stepArr.length
      };
    }
  }
};
</script>

<style lang="scss">
// 進度條
.stepOutsideBox {
  justify-content: space-around;
  margin-bottom: 2rem;

  .stepBox {
    width: calc(100% / var(--stepBarDivWidth));
    z-index: 1;
    // 上方數字
    &__upPart {
      position: relative;
      .span {
        width: 38px;
        height: 38px;
        font-size: 1.3rem;
        font-weight: 400;
        color: #ccc;
        border: 2px solid #ccc;
        border-radius: 50%;
        background-color: var(--spanDefaultColor);
        transition: all .3s;
        margin: 0 auto;
        z-index: 3;
      }

      // 目前進度到哪
      .span.active {
        background-color: var(--spanActiveColor);
        border-color: var(--spanActiveColor);
        color: #FFF;
      }

      &::after {
        content: '';
        position: absolute;
        width: 70%;
        height: 3px;
        top: 16px;
        left: 65%;
        background-color: #ccc;
        transition: all .3s;
        z-index: -1;
      }
    }

    // 目前進度到哪
    &__upPart.active::after {
      background-color: var(--spanActiveColor);
      transition: all .3s;
    }

    &:last-child {
      .stepBox__upPart::after {
        content: none;
      }
    }

    // 下方文字
    &__downPart {
      .span {
        color: #b9b9b9;
        transition: all .3s;
      }

      // 目前進度到哪
      .span.active {
        color: var(--spanActiveColor);
      }
    }
  }
}
</style>
